import { retrunAssets } from "../../utils/getAssets"
import BreadCrumbs from "../breadCrumbs"
import InformationCard from "./informationCard"
import { PropTypes } from 'prop-types';

const Banner = ({img}) => {
    const banner = retrunAssets(img)
    return (
        <div className="relative w-full h-full lg:h-screen bg-white">
            <div className="w-full relative h-[calc(30dvh)] lg:h-[80%] flex items-center justify-center bg-gray-300 bg-cover bg-no-repeat bg-center" style={{ backgroundImage: `url('${banner}')` }}>
                
                <div className="absolute inset-0 bg-[rgba(0,0,0,0.2)]"></div>
                <div className="hidden lg:flex lg:absolute lg:w-full lg:max-w-7xl lg:h-52   lg:-bottom-40">
                    <InformationCard />
                </div>

            </div>
            <div className="absolute top-[10%] left-1/2 -translate-x-1/2">
                <BreadCrumbs/>
            </div>
            <div className="flex py-8 lg:hidden">
                <InformationCard />
            </div>
        </div>
    )
}
Banner.propTypes = {
    img: PropTypes.string
}
export default Banner